import React from "react";
import { MDBPagination, MDBPageItem, MDBPageNav, MDBDataTable } from "mdbreact";
import * as misConstantes from "../../../js/constantes";
import InicioBreadcrumbs from "../../../pages/template/breadcrumbs/InicioBreadcrumbs.js";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import { Link } from "react-router-dom";

import axios from "axios";

class Cotizaciones extends React.Component {
  constructor(props) {
    super(props);

    var columnas = [
      { field: "numero", label: "Consecutivo", attributes: { width: "10%" } },
      {
        field: "simulacion",
        label: "Simulación",
        attributes: { width: "25%" },
      },
      { field: "entidad", label: "Entidad", attributes: { width: "30%" } },
      { field: "estado", label: "Estado", attributes: { width: "15%" } },
      {
        field: "fechaCierre",
        label: "Fecha cierre",
        attributes: { width: "15%" },
      },
      {
        field: "botones",
        label: "",
        sort: "asc",
        width: "5%",
        attributes: { width: "20%", align: "center" },
      },
    ];
    this.state = {
      datos: { columns: columnas, rows: [] },
      searchTerm: '',
      searchTimer: null,

      datosCotizacionesEnviadasAbiertas: { columns: columnas, rows: [] },
      datosCotizacionesSinEnviarAbiertas: { columns: columnas, rows: [] },

      mostrarInsertarCotizacion: false,
      fechaSolicitudInsertarCotizacion: "",
      fechaCierreInsertarCotizacion: "",
      estadoCierreInsertarCotizacion: "",
      respuestaInsertarCotizacion: "",
      mostrarEditarCotizacion: false,
      fechaSolicitudEditarCotizacion: "",
      fechaCierreEditarCotizacion: "",
      estadoCierreEditarCotizacion: "",
      idEditarSimulador: -1,
      respuestaEditarCotizacion: "",
      mostrarEliminarCotizacion: false,
      nombreEliminarCotizacion: "",
      idEliminarCotizacion: -1,
      respuestaEliminarCotizacion: "",
      columnas: columnas,
      paginaActual: 1,
      registrosPorPagina: 10,
      totalRegistros: -1,
      totalPaginas: 50,
      cargandoItemsCotizacion: "",
      paginasVisibles: 10,
      isLoading: false,
      tableKey: 0,
      searchTerm: '',
      totalRegistrosSinFiltrar: 0,
    };
  }
  componentWillUnmount() {
    // Limpiar el temporizador al desmontar el componente
    if (this.state.searchTimer) {
      clearTimeout(this.state.searchTimer);
    }
  }

  componentDidMount() {
    this.cargarCotizacionsSinEnviarAbiertas();
    this.cargarCotizacionsEnviadasAbiertas();
    /*********************************************** */
    // Carga inicial (página 1, tamaño por defecto)
    this.cargarPagina();
    /*********************************************** */
    //		this.cargarCotizacionsEnviadasAbiertas();
  }

  render() {
    return (
      <>
        <div
          class="menu"
          style={{
            backgroundColor: "#dbe7fc",
            width: "100%",
            padding: "10px",
            fontSize: "12px",
          }}
        >
          <div class="container">
            <InicioBreadcrumbs></InicioBreadcrumbs> / Cotizaciones
          </div>
        </div>
        <div
          class="container"
          style={{ minHeight: "550px", paddingTop: "30px" }}
        >
          <div class="subitulosPaginaNotificaciones">
            <b>Cotizaciones</b>
          </div>
          <br />

          <div style={{ display: this.state.mostrarTablasConSimulacion }}>
            <div style={{ display: this.state.mostrarTablasAbierto }}>
              <Tabs>
                <Tab
                  eventKey="cotizaciones_abiertas_sin_enviar"
                  title="Cotizaciones abiertas sin enviar"
                >
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    <br />
                    <MDBDataTable
                      striped={true}
                      bordered={true}
                      small
                      data={this.state.datosCotizacionesSinEnviarAbiertas}
                      hover={true}
                      entriesOptions={[5, 10, 15, 25]}
                      entries={15}
                      pagesAmount={4}
                      condensed={true}
                    />
                  </div>
                </Tab>
                <Tab
                  eventKey="cotizaciones_abiertas_enviadas"
                  title="Cotizaciones abiertas enviadas"
                >
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    <br />
                    <MDBDataTable
                      striped={true}
                      bordered={true}
                      small
                      data={this.state.datosCotizacionesEnviadasAbiertas}
                      hover={true}
                      entriesOptions={[5, 10, 15, 25]}
                      entries={15}
                      pagesAmount={4}
                      condensed={true}
                    />
                  </div>
                </Tab>
                <Tab
                  eventKey="cotizacionesFinalizadas"
                  title="Cotizaciones enviadas"
                >
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    <br />
                    <div style={{ position: "relative" }}>
                      {/* Overlay */}
                      {this.state.isLoading && (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(255,255,255,0.7)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 5,
                            backdropFilter: "blur(1px)",
                          }}
                          aria-busy="true"
                          aria-live="polite"
                        >
                          {/* react-bootstrap Spinner */}
                          <div className="text-center">
                            <div
                              className="spinner-border"
                              role="status"
                              aria-label="Cargando"
                            />
                            <div
                              className="mt-2 text-muted"
                              style={{ fontSize: 12 }}
                            >
                              Cargando…
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Tu info y tabla */}
                      {this.renderInfoPaginacion()}

                      <MDBDataTable
                        key={this.state.tableKey}
                        striped
                        bordered
                        small
                        data={this.state.datos}
                        hover
                        paging={false}
                        searching={false}
                        info={false}
                        entriesOptions={false}
                        condensed
                      />

                      <div className="d-flex flex-column align-items-center mt-3">
                        <div className="w-100 text-center mb-2">
                          {(() => {
                            const { paginaActual, registrosPorPagina, totalRegistros } = this.state;
                            const inicio = totalRegistros === 0 ? 0 : (paginaActual - 1) * registrosPorPagina + 1;
                            const fin = Math.min(paginaActual * registrosPorPagina, totalRegistros);
                            
                            return (
                              <span className="text-muted">
                                {totalRegistros === 0 
                                  ? "No se encontraron resultados"
                                  : `Mostrando ${inicio} a ${fin} de ${totalRegistros} items de cotización`
                                }
                              </span>
                            );
                          })()}
                        </div>
                        {this.renderPaginacion()}
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>

          <br />
          <br />

          {/**
				// ------------------------------------------------------------------------------------------------------
				// Cotizacion
				// ------------------------------------------------------------------------------------------------------
				 */}
        </div>
      </>
    );
  }

  // ----------------------------------------
  // Logica Paginacion
  // ----------------------------------------
  cargarPagina = async (
    pagina = this.state.paginaActual,
    tam = this.state.registrosPorPagina,
    totalPag = this.state.totalRegistros
  ) => {
    this.setState({
      isLoading: true,
      cargandoItemsCotizacion: "Cargando items de cotización...",
    });

    try {
      const { columns, rows, totalRegistros } = await this.cargarCotizacions(
        pagina,
        tam,
        totalPag
      );

      // Calcular el total de páginas basado en los resultados filtrados
      const totalPaginas = Math.max(1, Math.ceil((totalRegistros || 0) / tam));
      
      // Si la página actual es mayor que el total de páginas después del filtrado,
      // volver a la primera página
      if (pagina > totalPaginas && totalPaginas > 0) {
        return this.cargarPagina(1, tam, totalRegistros);
      }

      // Siempre usar el total del servidor para la paginación
      this.setState((prev) => ({
        paginaActual: pagina,
        registrosPorPagina: tam,
        totalRegistros: totalRegistros, // Usar siempre el total del servidor
        totalPaginas,
        datos: { columns: [...columns], rows: [...rows] },
        tableKey: (prev.tableKey ?? 0) + 1
      }));
    } catch (e) {
      console.error(e);
    } finally {
      // ⬅️ SIEMPRE se ejecuta: apaga el loader y limpia el texto
      this.setState({ isLoading: false, cargandoItemsCotizacion: "" });
    }
  };

  cambiarPagina = (nuevaPagina) => {
    if (nuevaPagina >= 1 && nuevaPagina <= this.state.totalPaginas) {
      this.cargarPagina(nuevaPagina, this.state.registrosPorPagina);
    }
  };

  cambiarRegistrosPorPagina = (nuevosRegistros) => {
    this.cargarPagina(1, nuevosRegistros);
  };

  obtenerPaginasVisibles = () => {
    const { paginaActual, totalPaginas, paginasVisibles } = this.state;
    const mitad = Math.floor(paginasVisibles / 2);
    let inicio = Math.max(1, paginaActual - mitad);
    let fin = Math.min(totalPaginas, inicio + paginasVisibles - 1);

    if (fin - inicio + 1 < paginasVisibles) {
      inicio = Math.max(1, fin - paginasVisibles + 1);
    }

    const paginas = [];
    for (let i = inicio; i <= fin; i++) {
      paginas.push(i);
    }
    return paginas;
  };

  renderPaginacion = () => {
    const { paginaActual, totalPaginas, isLoading } = this.state;
    const paginasVisibles = this.obtenerPaginasVisibles();
    if (totalPaginas <= 1) return null;

    return (
      <div
        className="d-flex justify-content-end"
        aria-disabled={isLoading}
      >
        <MDBPagination>
          <MDBPageItem disabled={paginaActual === 1 || isLoading}>
            <MDBPageNav onClick={() => !isLoading && this.cambiarPagina(1)}>
              ««
            </MDBPageNav>
          </MDBPageItem>
          <MDBPageItem disabled={paginaActual === 1 || isLoading}>
            <MDBPageNav
              onClick={() => !isLoading && this.cambiarPagina(paginaActual - 1)}
            >
              ‹
            </MDBPageNav>
          </MDBPageItem>

          {paginasVisibles.map((pagina) => (
            <MDBPageItem
              key={pagina}
              active={pagina === paginaActual}
              disabled={isLoading}
            >
              <MDBPageNav
                onClick={() => !isLoading && this.cambiarPagina(pagina)}
              >
                {pagina}
              </MDBPageNav>
            </MDBPageItem>
          ))}

          <MDBPageItem disabled={paginaActual === totalPaginas || isLoading}>
            <MDBPageNav
              onClick={() => !isLoading && this.cambiarPagina(paginaActual + 1)}
            >
              ›
            </MDBPageNav>
          </MDBPageItem>
          <MDBPageItem disabled={paginaActual === totalPaginas || isLoading}>
            <MDBPageNav
              onClick={() => !isLoading && this.cambiarPagina(totalPaginas)}
            >
              »»
            </MDBPageNav>
          </MDBPageItem>
        </MDBPagination>
      </div>
    );
  };

  renderInfoPaginacion = () => {
    return (
      	<div className="row mb-4">
			{/* Columna izquierda: paginación */}
			<div className="col-6 d-flex align-items-center">
				<span className="text-muted mr-2">Items por página:</span>
				<select
				value={this.state.registrosPorPagina}
				onChange={(e) =>
					!this.state.isLoading &&
					this.cambiarRegistrosPorPagina(parseInt(e.target.value))
				}
				className="form-control form-control-sm"
				style={{ width: "auto" }}
				disabled={this.state.isLoading}
				>
				<option value={5}>5</option>
				<option value={10}>10</option>
				<option value={25}>25</option>
				<option value={50}>50</option>
				</select>
			</div>

			{/* Columna derecha: buscador */}
			<div className="col-6 d-flex justify-content-end">
				<input
				type="text"
				className="form-control form-control-sm"
				style={{ width: "200px" }}
				placeholder="Buscar por consecutivo"
				value={this.state.searchTerm}
				onChange={(e) => {
					const newSearchTerm = e.target.value;
					this.setState({ searchTerm: newSearchTerm });

					if (this.state.searchTimer) {
					clearTimeout(this.state.searchTimer);
					}

					const timer = setTimeout(() => {
					this.cargarPagina(1, this.state.registrosPorPagina);
					}, 1000);

					this.setState({ searchTimer: timer });
				}}
				disabled={this.state.isLoading}
				/>
			</div>
	  	</div>
    );
  };
  // ----------------------------------------
  // Cargar Cotizacion
  // ----------------------------------------

  cargarCotizacions = async (numPag, numReg, totalReg) => {
    const codigo = localStorage.getItem(
      "simuladores.proveedores.codigoUsuario"
    );
    const info = { 
      codigo, 
      numPag, 
      numReg, 
      totalReg,
      searchTerm: this.state.searchTerm || null
    };

    try {
      const response = await axios.post(
        misConstantes.URL_CONSULTA + "/ServletCotizacionesCerradasPaginadas",
        info,
        { params: info }
      );

      const datosFinales = response?.data ?? [];
      const columns = this.state.columnas || [];

      const rows = [];
      let totalRegistros = 0;

      // Manejar el caso cuando no hay datos
      if (datosFinales.length === 0) {
        return { columns, rows, totalRegistros: 0 };
      }

      // El primer elemento siempre contiene el total de registros
      if (datosFinales[0] && typeof datosFinales[0].totalCotizacionesCerradas === "number") {
        totalRegistros = datosFinales[0].totalCotizacionesCerradas;
      }

      // Procesar los registros, excluyendo el primer elemento si solo contiene el total
      const startIndex = datosFinales[0].hasOwnProperty('id') ? 0 : 1;
      for (let i = startIndex; i < datosFinales.length; i++) {
        const item = datosFinales[i];
        rows.push({
          numero: item.simulacion?.consecutivo,
          entidad: item.entidad?.nombre,
          simulacion: item.simulador?.nombre,
          estado: item.simulacion?.nombreEstadoProceso,
          fechaCierre: item.eventoCotizacion?.sfechaRespuesta,
          botones: (
            <div style={{ width: "100%", textAlign: "center" }}>
              <Link to={`/cotizacion/${item.id}`}>
                <i className="fas fa-info-circle"></i>
              </Link>
            </div>
          ),
        });
      }

      return { columns, rows, totalRegistros };
    } catch (e) {
      console.error("Error en cargarCotizacions:", e);
      throw e;
    }
  };
  cargarCotizacionsSinEnviarAbiertas() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var info = { codigo: codigo };

    //		alert( URL_CONSULTA );
    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletCotizacionesSinEnviarAbiertas",
        info,
        { params: info }
      )
      .then(
        function (response) {
          //			alert( JSON.stringify( response.data )  );
          var datosFinales = response.data;

          var columns = this.state.columnas;
          var rows = [];
          for (var i = 0; i < datosFinales.length; i++) {
            const identificador = datosFinales[i].id + "";
            var consecutivo = datosFinales[i].simulacion.consecutivo;
            var nombreEnitdad = datosFinales[i].entidad.nombre;
            var estado = datosFinales[i].simulacion.nombreEstadoProceso;
            var nombreSimulador = datosFinales[i].simulador.nombre;
            var row = {
              numero: consecutivo,
              entidad: nombreEnitdad,
              simulacion: nombreSimulador,
              estado: estado,
              fechaCierre: datosFinales[i].eventoCotizacion.sfechaRespuesta,

              botones: (
                <div style={{ width: "100%", textAlign: "center" }}>
                  <Link to={"/cotizacion/" + datosFinales[i].id}>
                    <i class="fas fa-info-circle"></i>
                  </Link>
                  &nbsp;
                </div>
              ),
            };
            rows.push(row);
          }

          var datosCotizacionesSinEnviarAbiertas = {
            columns: columns,
            rows: rows,
          };
          this.setState({
            datosCotizacionesSinEnviarAbiertas:
              datosCotizacionesSinEnviarAbiertas,
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }
  cargarCotizacionsEnviadasAbiertas() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var info = { codigo: codigo };

    //		alert( URL_CONSULTA );
    axios
      .post(
        misConstantes.URL_CONSULTA + "/ServletCotizacionesEnviadasAbiertas",
        info,
        { params: info }
      )
      .then(
        function (response) {
          //			alert( JSON.stringify( response.data )  );
          var datosFinales = response.data;

          var columns = this.state.columnas;
          var rows = [];
          for (var i = 0; i < datosFinales.length; i++) {
            const identificador = datosFinales[i].id + "";
            var consecutivo = datosFinales[i].simulacion.consecutivo;
            var nombreEnitdad = datosFinales[i].entidad.nombre;
            var estado = datosFinales[i].simulacion.nombreEstadoProceso;
            var nombreSimulador = datosFinales[i].simulador.nombre;
            var row = {
              numero: consecutivo,
              entidad: nombreEnitdad,
              simulacion: nombreSimulador,
              estado: estado,
              fechaCierre: datosFinales[i].eventoCotizacion.sfechaRespuesta,

              botones: (
                <div style={{ width: "100%", textAlign: "center" }}>
                  <Link to={"/cotizacion/" + datosFinales[i].id}>
                    <i class="fas fa-info-circle"></i>
                  </Link>
                  &nbsp;
                </div>
              ),
            };
            rows.push(row);
          }

          var datosCotizacionesEnviadasAbiertas = {
            columns: columns,
            rows: rows,
          };
          this.setState({
            datosCotizacionesEnviadasAbiertas:
              datosCotizacionesEnviadasAbiertas,
          });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  //	datosCotizacionesEnviadasAbiertas: {columns: columnas, rows:[]},
  //								datosCotizacionesSinEnviarAbiertas: {columns: columnas, rows:[]},
}

export default Cotizaciones;
